module.exports = __webpack_public_path__ + "static/media/icon-document.3a638d01.svg";